export default {
    namespaced: true,
    state: {
        baseData: {
            states: [
                { code: "AL", name: "Alabama" },
                { code: "AK", name: "Alaska" },
                { code: "AZ", name: "Arizona" },
                { code: "AR", name: "Arkansas" },
                { code: "CA", name: "California" },
                { code: "CO", name: "Colorado" },
                { code: "CT", name: "Connecticut" },
                { code: "DE", name: "Delaware" },
                { code: "FL", name: "Florida" },
                { code: "GA", name: "Georgia" },
                { code: "HI", name: "Hawaii" },
                { code: "ID", name: "Idaho" },
                { code: "IL", name: "Illinois" },
                { code: "IN", name: "Indiana" },
                { code: "IA", name: "Iowa" },
                { code: "KS", name: "Kansas" },
                { code: "KY", name: "Kentucky" },
                { code: "LA", name: "Louisiana" },
                { code: "ME", name: "Maine" },
                { code: "MD", name: "Maryland" },
                { code: "MA", name: "Massachusetts" },
                { code: "MI", name: "Michigan" },
                { code: "MN", name: "Minnesota" },
                { code: "MS", name: "Mississippi" },
                { code: "MO", name: "Missouri" },
                { code: "MT", name: "Montana" },
                { code: "NE", name: "Nebraska" },
                { code: "NV", name: "Nevada" },
                { code: "NH", name: "New Hampshire" },
                { code: "NJ", name: "New Jersey" },
                { code: "NM", name: "New Mexico" },
                { code: "NY", name: "New York" },
                { code: "NC", name: "North Carolina" },
                { code: "ND", name: "North Dakota" },
                { code: "OH", name: "Ohio" },
                { code: "OK", name: "Oklahoma" },
                { code: "OR", name: "Oregon" },
                { code: "PA", name: "Pennsylvania" },
                { code: "RI", name: "Rhode Island" },
                { code: "SC", name: "South Carolina" },
                { code: "SD", name: "South Dakota" },
                { code: "TN", name: "Tennessee" },
                { code: "TX", name: "Texas" },
                { code: "UT", name: "Utah" },
                { code: "VT", name: "Vermont" },
                { code: "VA", name: "Virginia" },
                { code: "WA", name: "Washington" },
                { code: "WV", name: "West Virginia" },
                { code: "WI", name: "Wisconsin" },
                { code: "WY", name: "Wyoming" },
            ],
            terms: [
                { code: "fex", name: "Final Expense" },
                { code: "10", name: "Term 10 Year" },
                { code: "15", name: "Term 15 Year" },
                { code: "20", name: "Term 20 Year" },
                { code: "25", name: "Term 25 Year" },
                { code: "30", name: "Term 30 Year" },
            ],
            jobStatus: [
                { code: "1", name: "Currently Employed" },
                { code: "2", name: "Retired" },
                { code: "3", name: "On Disability" },
                { code: "4", name: "Homemaker / Other" },
            ],
            relatives: [
                { id: 1, body: "Son" },
                { id: 2, body: "Daughter" },
                { id: 3, body: "Wife" },
                { id: 4, body: "Husband" },
                { id: 5, body: "Other" },
            ],
            disabilities: [
                { code: "1", name: "Casket" },
                { code: "2", name: "Cremation" },
                { code: "3", name: "I am not sure" },
            ],
            medications: [
                { code: "1", name: "Anxiety, depression, or bipolar" },
                { code: "2", name: "Cancer" },
                { code: "3", name: "Chronic pain" },
                { code: "4", name: "Diabetes" },
                { code: "5", name: "Heart or circulatory disorder" },
                { code: "6", name: "Respiratory disorder" },
                { code: "7", name: "Aids hiv" },
                { code: "8", name: "Alcohol drug abuse" },
                { code: "9", name: "Alzheimers dementia" },
                { code: "10", name: "Clinical depression" },
                { code: "11", name: "Emphysema" },
                { code: "12", name: "Epilepsy" },
                { code: "13", name: "Heart attack" },
                { code: "14", name: "Heart disease" },
                { code: "15", name: "Hepatitis liver" },
                { code: "16", name: "High blood pressure" },
                { code: "17", name: "High cholesterol" },
                { code: "18", name: "Kidney disease" },
                { code: "19", name: "Mental illness" },
                { code: "20", name: "Multiple sclerosis" },
                { code: "21", name: "Pulmonary disease" },
                { code: "22", name: "Stroke" },
                { code: "23", name: "Uclers" },
                { code: "24", name: "Vascular Disease" },
                { code: "25", name: "Other medical condition" },
                { code: "26", name: "I have no medical conditions" },
            ],
            mediaalphaMedications: [
                { code: "1", name: "Aids hiv" },
                { code: "2", name: "Alcohol drug abuse" },
                { code: "3", name: "Alzheimers dementia" },
                { code: "4", name: "Asthma" },
                { code: "5", name: "Cancer" },
                { code: "6", name: "Clinical Depression" },
                { code: "7", name: "Diabetes" },
                { code: "8", name: "Emphysema" },
                { code: "9", name: "Epilepsy" },
                { code: "10", name: "Heart Attack" },
                { code: "11", name: "Heart Disease" },
                { code: "12", name: "Hepatitis Liver" },
                { code: "13", name: "High blood pressure" },
                { code: "14", name: "High Cholesterol" },
                { code: "15", name: "Kidney Disease" },
                { code: "16", name: "Mental Illness" },
                { code: "17", name: "Multiple Sclerosis" },
                { code: "18", name: "Pulmonary Disease" },
                { code: "19", name: "Stroke" },
                { code: "20", name: "Ulcers" },
                { code: "21", name: "Vascular Disease" },
                { code: "22", name: "Other" },
            ],
            healthMedications: [
                { code: "major_condition_aids_hiv", name: "Aids hiv" },
                { code: "major_condition_alcohol_drug_abuse", name: "Alcohol drug abuse" },
                { code: "major_condition_alzheimers_dementia", name: "Alzheimers dementia"},
                { code: "major_condition_asthma", name: "Asthma" },
                { code: "major_condition_cancer", name: "Cancer" },
                { code: "major_condition_clinical_depression", name: "Clinical Depression" },
                { code: "major_condition_diabetes", name: "Diabetes" },
                { code: "major_condition_emphysema", name: "Emphysema" },
                { code: "major_condition_epilepsy", name: "Epilepsy" },
                { code: "major_condition_heart_attack", name: "Heart Attack" },
                { code: "major_condition_heart_disease", name: "Heart Disease" },
                { code: "major_condition_hepatitis_liver", name: "Hepatitis Liver" },
                { code: "major_condition_high_blood_pressure", name: "High blood pressure" },
                { code: "major_condition_high_cholesterol", name: "High Cholesterol" },
                { code: "major_condition_kidney_disease", name: "Kidney Disease" },
                { code: "major_condition_mental_illness", name: "Mental Illness" },
                { code: "major_condition_multiple_sclerosis", name: "Multiple Sclerosis" },
                { code: "major_condition_pulmonary_disease", name: "Pulmonary Disease" },
                { code: "major_condition_stroke", name: "Stroke" },
                { code: "major_condition_ulcers", name: "Ulcers" },
                { code: "major_condition_vascular_disease", name: "Vascular Disease" },
                { code: "major_condition_other", name: "Other" },
            ],
            rateClass: [
                { code: "pp", name: "Preferred Plus" },
                { code: "p", name: "Preferred" },
                { code: "sp", name: "Standard Plus" },
                { code: "s", name: "Standard" },
            ],
            fexRateClass: [
                { code: "lb", name: "Level Benefits" },
                { code: "gb", name: "Graded Benefits" },
                { code: "gi", name: "Guaranteed Issue" },
            ],
            months: [
                { code: '01', name: "January" },
                { code: '02', name: "February" },
                { code: '03', name: "March" },
                { code: '04', name: "April" },
                { code: '05', name: "May" },
                { code: '06', name: "June" },
                { code: '07', name: "July" },
                { code: '08', name: "August" },
                { code: '09', name: "September" },
                { code: '10', name: "October" },
                { code: '11', name: "November" },
                { code: '12', name: "December" },
            ],
            heights: [
                { value: 53, text: "4'5" },
                { value: 54, text: "4'6" },
                { value: 55, text: "4'7" },
                { value: 56, text: "4'8" },
                { value: 57, text: "4'9" },
                { value: 58, text: "4'10" },
                { value: 59, text: "4'11" },
                { value: 60, text: "5'0" },
                { value: 61, text: "5'1" },
                { value: 62, text: "5'2" },
                { value: 63, text: "5'3" },
                { value: 64, text: "5'4" },
                { value: 65, text: "5'5" },
                { value: 66, text: "5'6" },
                { value: 67, text: "5'7" },
                { value: 68, text: "5'8" },
                { value: 69, text: "5'9" },
                { value: 70, text: "5'10" },
                { value: 71, text: "5'11" },
                { value: 72, text: "6'0" },
                { value: 73, text: "6'1" },
                { value: 74, text: "6'2" },
                { value: 75, text: "6'3" },
                { value: 76, text: "6'4" },
                { value: 77, text: "6'5" },
                { value: 78, text: "6'6" },
                { value: 79, text: "6'7" },
                { value: 80, text: "6'8" },
                { value: 81, text: "6'9" },
                { value: 82, text: "6'10" },
                { value: 83, text: "6'11" },
            ],
            childrens: ["1", "2", "3+"],
            covarageAmounts: [],
            covarageAmountsFEX: [],
            status: [
                {
                    code: "newLead",
                    name: "New Lead"
                },
                {
                    code: "contactAttempt1",
                    name: "Contact attempt 1"
                },
                {
                    code: "contactAttempt2",
                    name: "Contact attempt 2"
                },
                {
                    code: "contactAttempt3",
                    name: "Contact attempt 3"
                },
                {
                    code: "contactAttempt4",
                    name: "Contact attempt 4"
                },
                {
                    code: "notInterested",
                    name: "Did not want quote",
                },
                {
                    code: "doNotCall",
                    name: "Do not call"
                },
                {
                    code: "wrongPhoneNumber",
                    name: "Wrong Phone number",
                },
                {
                    code: "followUp",
                    name: "Follow up",
                },
                {
                    code: "thinkingAboutIt",
                    name: "Thinking about it",
                },
                {
                    code: "emailed",
                    name: "Emailed"
                },
                {
                    code: "inApplication",
                    name: "In Application"
                },
                {
                    code: "underwriting",
                    name: "Underwriting"
                },
                {
                    code: "purchased",
                    name: "Purchased"
                },
                {
                    code: "in-force",
                    name: "In-force"
                },
                {
                    code: "declined",
                    name: "Declined"
                },
                {
                    code: "cancelled",
                    name: "Cancelled"
                },
                {
                    code: "priceTooHigh",
                    name: "Price Too High"
                },
            ],
            terms_ma: [
                "Final Expense",
                "Term 10 Years",
                "Term 15 Years",
                "Term 20 Years",
                "Term 25 Years",
                "Term 30 Years",
            ],
            marital_status: [
                { code: "single", name: "Single" },
                { code: "married", name: "Married" },
                { code: "divorced", name: "Divorced" },
                { code: "separated", name: "Separated" },
                { code: "widowed", name: "Widowed" },
                { code: "domestic partner", name: "Domestic Partner" },
                { code: "unknown", name: "Unknown" },
            ],
            current_company: [
                "AAA",
                "AARP",
                "Aflac",
                "AIG Direct",
                "Allianz",
                "Allstate",
                "American Family",
                "American General",
                "American National ",
                "Aviva",
                "AXA Equitable",
                "Banner Life / Legal & General",
                "Colonial Penn",
                "Farmers",
                "Fidelity Life",
                "Generation",
                "Genworth Financial",
                "Gerber Life",
                "Globe Life",
                "Hartford Life",
                "ING",
                "Jackson National",
                "John Hancock",
                "Liberty Mutual",
                "Lincoln Financial Group",
                "Mass Mutual",
                "Matrix Direct",
                "MetLife",
                "Mutual of Omaha",
                "Nationwide",
                "New York Life",
                "North American",
                "Northwestern Mutual",
                "NSBC",
                "Pacific Life",
                "Primerica",
                "Principal",
                "Protective",
                "Prudential",
                "ReliaStar",
                "SBLI",
                "State Farm",
                "TransAmerica",
                "USAA",
                "West Coast Life",
                "William Penn",
                "Other",
            ],
            quoter_companies: [
                { code: 'liberty_bankers', body: 'Liberty Bankers' },
                { code: 'accendo_life', body: 'Accendo atena life insurance' },
                { code: 'royal_neighbors', body: 'Royal Neighbors of America' },
                { code: 'great_western', body: 'Great Western' },
                { code: 'statefarm', body: 'StateFarm' },
                { code: 'ethos', body: 'Ethos' },
                { code: 'banner', body: 'Banner' },
                { code: 'prosperity_life', body: 'Prosperity' },
            ],
            health_current_company: [
                "AETNA",
                "Aflac",
                "American Family Insurance",
                "American Republic Insurance",
                "Assurant",
                "Atlantis Health Plan",
                "Blue Cross Blue Shield",
                "Celtic Insurance",
                "CIGNA",
                "Farm Bureau Insurance",
                "Golden Rule Insurance",
                "Health Net",
                "Health Plus of America",
                "Healthmarkets",
                "Humana",
                "InSphere",
                "Kaiser Permanente",
                "LifeWise Health Plan",
                "Metlife Insurance",
                "Oxford Health Plans",
                "PacifiCare",
                "State Farm Insurance",
                "Time Insurance",
                "Tufts Health Plan",
                "Unicare",
                "United American Insurance",
                "United HealthCare",
                "Vista Health Plan",
                "Other",
            ],
            credit_rating: [
                { code: "excellent", name: "Excellent" },
                { code: "good", name: "Good" },
                { code: "average", name: "Average" },
                { code: "below averaname", name: "Below average" },
                { code: "poor", name: "Poor" },
            ],
            gender: [
                { code: "M", name: "M" },
                { code: "F", name: "F" },
                { code: "X", name: "X" },
            ],
            qualifying_life_event: [
                "none",
                "marriage or divorce",
                "job loss / job change",
                "permanent move",
                "birth or adoption of a child",
                "other",
            ],
            coverage_type: [
                "Individual Family",
                "Short Term",
                "COBRA",
                "Discount Plan",
                "Medicaid",
                "Maternity Only",
                "Dental Only",
                "Vision Only",
                "Prescription Only",
                "Other Health",
            ],
        },
    },
    mutations: {},
    getters: {
        baseData(state) {

            for (let i = 1000; i <= 50000; i += 1000) {
                state.baseData.covarageAmountsFEX.push({ code: i, name: i });
            }

            for (let i = 10000; i <= 2000000; i += 10000) {
                state.baseData.covarageAmounts.push({ code: i, name: i });
            }

            return state.baseData;
        },

        status(state) {
            let status = state.baseData.status;
            status.shift();
            return status;
        },

        heightNumbers: state => state.baseData.heights,
        states: state => state.baseData.states,
        relatives: state => state.baseData.relatives
    },
    actions: {},
}
